import TaskListItems, {
  configOptions as taskListItemsConfigOptions,
  icon as taskListItemsIcon,
} from '../components/dashboardModules/TaskListItems'

export const generateAvailableModules = () => ({
  TaskListItems: {
    component: TaskListItems,
    configOptions: taskListItemsConfigOptions,
    icon: taskListItemsIcon,
    id: 'TaskListItems',
    title: 'Tasks',
  },
})

export const dashboardDefaultLayout = {
  columns: {
    main: {
      id: 'main',
      modules: [
        {
          key: 'TaskListItems-1',
          moduleId: 'TaskListItems',
        },
      ],
    },
    sidebar: {
      id: 'sidebar',
      modules: [],
    },
  },
  custom: false,
  options: {
    'TaskListItems-1': {
      customization: {
        title: 'Tasks',
      },
      queryParams: {
        assignee_id: 'current_user',
        limit: 25,
        priority: 'all',
        task_type: 'all',
      },
    },
  },
}
